import { cn } from "@/lib/utils";

const SectionCardSubTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <span
      className={cn(
        "text-[18px] text-g-700 font-extralight  ",
        className
      )}
    >
      {children}
    </span>
  );
};

export default SectionCardSubTitle;
